import { createSlice, PayloadAction } from '@reduxjs/toolkit'
/* eslint-disable no-param-reassign */

import {
  AddressState,
  SetAddressPayload,
  AddressType,
  AddressesOptions,
} from '../models/address.model'

export const addressInitialState = {
  data: {
    addressInput: '',
    number: '',
    postalCode: '',
    floor: '',
    letter: '',
    otherInfo: '',
    town: '',
    province: '',
    gescal: '',
    streetType: '',
    streetName: '',
    provinceId: '',
    summary: '',
  },
  addressOwner: AddressesOptions.OTHER,
  loading: false,
  errorMessage: '',
  errorCode: '',
}

const initialData = Object.values(AddressType)
  .map((type) => ({ [type]: addressInitialState }))
  .reduce((curr, next) => ({ ...curr, ...next }))

export const initialState: AddressState = {
  mainLine: initialData,
  all: initialData,
}

export const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setAddressAction(
      state,
      { payload: { id, addressType, address } }: PayloadAction<SetAddressPayload>,
    ) {
      return {
        ...state,
        [id]: {
          ...state[id],
          [addressType]: {
            ...state[id][addressType],
            data: {
              ...state[id][addressType].data,
              ...address,
              number: address.number !== null ? address.number : state[id][addressType].data.number,
            },
          },
        },
      }
    },
    createNewAddressStructure: (state, action: PayloadAction<string>) => {
      const { payload } = action
      return {
        ...state,
        [payload]: Object.values(AddressType)
          .map((type) => ({
            [type]: {
              ...addressInitialState,
              addressOwner: AddressesOptions.SAME,
            },
          }))
          .reduce((curr, next) => ({ ...curr, ...next })),
      }
    },
    deleteAddress: (state, action: PayloadAction<string>) => {
      const { payload } = action
      delete state[payload]
      return state
    },
    setAddressOwnerAction(
      state,
      {
        payload: { id, addressType, addressOwner },
      }: PayloadAction<{ id: string; addressType: AddressType; addressOwner: AddressesOptions }>,
    ) {
      return {
        ...state,
        [id]: {
          ...state[id],
          [addressType]: {
            ...addressInitialState,
            addressOwner,
          },
        },
      }
    },
    resetAddressAction(
      state,
      { payload: { id, addressType } }: PayloadAction<{ id: string; [key: string]: string }>,
    ) {
      const addressOwner =
        (state && state[id] && state[id][addressType] && state[id][addressType].addressOwner) ||
        AddressesOptions.SAME
      return {
        ...state,
        [id]: {
          ...state[id],
          [addressType]: {
            ...addressInitialState,
            addressOwner,
          },
        },
      }
    },
    resetAllAddressAction(_state) {
      return { ...initialState }
    },
  },
})

export const {
  setAddressAction,
  createNewAddressStructure,
  deleteAddress,
  resetAddressAction,
  resetAllAddressAction,
  setAddressOwnerAction,
} = addressSlice.actions

const addressReducer = addressSlice.reducer
export default addressReducer
